import http_request from './http_request'
import config from 'config'

function getFeatureFlags() {
	return http_request.get(`${config.api}feature_flags`)
		.send()
}

export default {
	getFeatureFlags,
}
